import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import { objectToNullNmmDomain } from '../../../../../../../../student/utils/utils';
import classes from './StudyGroupSelectCard.module.css';

const StudyGroupSelectCard = ({ group, isActive, selectable, onSelect }) => {
  const domains = useSelector(state => state.uiData.domains);
  const domain = useMemo(() => domains?.find(d => d.name === group?.domainName) || objectToNullNmmDomain(group?.domainName), [domains, group?.domainName]);
  const imageUrl = domain?.cardDomainImg || domain?.matriculation?.cardDomainImg;

  return (
    <AccessibilityClickableDiv
      className={`${classes.Card} ${isActive ? classes.Active : ''} ${!selectable ? classes.Disable : ''}`}
      onClick={selectable ? () => onSelect(group) : undefined}
    >
      {!selectable && group?.disable &&
        <div className={classes.Tooltip}>{group?.message}</div>
      }
      <img className={classes.Image} src={imageUrl} />
      <p className={classes.Name}>{group?.name}</p>
    </AccessibilityClickableDiv>
  );
};

export default StudyGroupSelectCard;